interface TextActionsProps {
  isGenerating: boolean;
  onGenerate: () => void;
}

export default function TextActions({
  isGenerating,
  onGenerate,
}: TextActionsProps) {
  return (
    <div className="text-actions">
        <button
        type="button"
        className="btn-primary"
        onClick={onGenerate}
        disabled={isGenerating}
        >
        {isGenerating
            ? "Wird generiert..."
            : "Social Media Post erstellen"}
        </button>
    </div>
  );
}